/* global window, document, Date, parseFloat, encodeURIComponent, decodeURIComponent */
export const BrowserGlobals = { window, document, Date, parseFloat, encodeURIComponent, decodeURIComponent };
